export default __webpack_public_path__ + "static/media/back-arrow.80f03fd6.png";